import React from "react";
import EventForm from "../../components/forms/Communicate/Event"
import Footer from "../../components/Footer";
import NavBar from "../../components/navbar-components/NavBar";

const Event = () => {
    return (
        <>
        <NavBar/>
        <div className="bg-gray-200 py-5">
            <EventForm/>
        </div>
        <Footer/>
        </>
    )
}

export default Event